












































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
import edit from './ChannelTypesEdit.vue';
import EditRate from './EditMerchantRate.vue';
@Component({
    components: { edit, EditRate }
})
export default class suppliermanage extends pagelist {
    get prox() {
        return new proxy.ChannelTypeServiceProxy();
    }
    input: proxy.ChannelTypePageInputDto = new proxy.ChannelTypePageInputDto();
    sub_id = 0;
    createOrEditShow = false;
    editRateShow = false;
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },

        {
            title: '名称',
            key: 'name'
        },
        {
            title: '编号',
            key: 'code',
            sortable: 'custom'
        },
        {
            title: '费率(%)',
            key: 'rate'
        },
        {
            title: '是否启用',
            slot: 'isEnable'
        },
        {
            title: '绑定通道',
            slot: 'channelTypeChannels'
        },
        {
            title: '操作',
            slot: 'oper'
        }
    ];
    sortchange(a) {
        if (a.order == 'desc') {
            this.sorting = (a.column.slot || a.column.key) + ' desc, id desc'
        }
        if (a.order == 'asc') {
            this.sorting = (a.column.slot || a.column.key) + ' asc, id desc'
        }
        if (a.order == "normal") {
            this.sorting = '';
        }
        this.getpage();
    }
    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
        this.prox.queryModelList(this.input).then(x => {
            this.dataList = x.items;
            this.showPaging(x);
        });
    }

    getpage() {
        this.OnInit();
    }
    async created() {
        this.getpage();
    }
    create() {
        this.createOrEditShow = true;
        this.sub_id = undefined;
    }
    edit(row) {
        if (!row) {
            if (this.selectedDataItems.length == 0) {
                this.$Notice.error({ title: '请选中一条数据' });
                return;
            }
            row = this.selectedDataItems[0];
        }
        this.sub_id = row.id;
        this.createOrEditShow = true;
    }

    unbundle(row){
        if (!row) {
            if (this.selectedDataItems.length == 0) {
                this.$Notice.error({ title: '请选中一条数据' });
                return;
            }
            row = this.selectedDataItems[0];
        }
        this.$Modal.confirm({
            title: '解绑负利润通道提醒',
            content: '确定要解绑该产品下的负利润通道吗？请确认选择的产品正确再点击确认！',
            onOk: () => {
                var ids = this.selectedDataItems.map(x => x.id)
                console.log(ids)
                var req = new proxy.IdsDto();
                req.idList = ids;
                this.prox.unbundleNegativeMerchant(req).then(x => {
                    this.$Message.success("已解绑负利润通道")
                })
            }
        })
    }

    del(row) {

        this.$Modal.confirm({
            title: '你确定要删除吗?删除后将无法恢复',
            onOk: () => {

                this.prox.deletes([row.id]).then(() => {
                    this.$Notice.success({ title: '删除成功' });
                    this.getpage();
                });
            }
        });
    }
}
